<div class="w-full h-8 relative flex items-center bg-[#D9D9D9] rounded-lg">
    <span
        class="flex items-center justify-center w-12 h-full bg-primary text-white cursor-pointer hover:bg-primary-hover transition-all rounded-l-lg duration-150"
        (click)="backDate()"
    >
        <i class="fa fa-angle-left text-white!"></i>
    </span>

    <div class="flex-1 h-full flex items-center justify-center px-2 min-w-30">
        <span
            class="w-full text-center font-normal text-sm capitalize cursor-pointer select-none"
            (click)="openCloseOpcoes($event)"
        >
            {{ dataLabel }}
        </span>
    </div>

    <span
        class="flex items-center justify-center w-12 h-full bg-primary text-white cursor-pointer hover:bg-primary-hover transition-all rounded-r-lg duration-150"
        (click)="nextDate()"
    >
        <i class="fa fa-angle-right text-white!"></i>
    </span>

    <div
        class="absolute left-0 top-[calc(100%+0.25rem)] w-full flex flex-col bg-[#F5F8F9] p-2 shadow-lg rounded-md transition-all duration-300 z-50"
        [ngClass]="
            exibirOpcoesMes
                ? 'opacity-100 visible translate-y-0'
                : 'opacity-0 invisible -translate-y-2'
        "
        (clickOutside)="clickOutside()"
    >
        <div class="w-full mb-2">
            <p-select
                styleClass="w-full"
                class="w-full block"
                [options]="anosOptions"
                [ngModel]="yearValueToDropdown"
                (onChange)="setYear($event)"
            ></p-select>
        </div>

        <div class="w-full grid grid-cols-3 gap-1">
            <div
                class="flex justify-center items-center py-2 px-1 font-bold cursor-pointer rounded transition-colors text-sm"
                [ngClass]="
                    dataInit.getMonth() === 0
                        ? 'bg-primary text-white'
                        : 'hover:bg-[#DCE2E7] text-gray-700'
                "
                (click)="setMonth(0)"
            >
                Jan
            </div>

            <div
                class="flex justify-center items-center py-2 px-1 font-bold cursor-pointer rounded transition-colors text-sm"
                [ngClass]="
                    dataInit.getMonth() === 1
                        ? 'bg-primary text-white'
                        : 'hover:bg-[#DCE2E7] text-gray-700'
                "
                (click)="setMonth(1)"
            >
                Fev
            </div>

            <div
                class="flex justify-center items-center py-2 px-1 font-bold cursor-pointer rounded transition-colors text-sm"
                [ngClass]="
                    dataInit.getMonth() === 2
                        ? 'bg-primary text-white'
                        : 'hover:bg-[#DCE2E7] text-gray-700'
                "
                (click)="setMonth(2)"
            >
                Mar
            </div>

            <div
                class="flex justify-center items-center py-2 px-1 font-bold cursor-pointer rounded transition-colors text-sm"
                [ngClass]="
                    dataInit.getMonth() === 3
                        ? 'bg-primary text-white'
                        : 'hover:bg-[#DCE2E7] text-gray-700'
                "
                (click)="setMonth(3)"
            >
                Abr
            </div>

            <div
                class="flex justify-center items-center py-2 px-1 font-bold cursor-pointer rounded transition-colors text-sm"
                [ngClass]="
                    dataInit.getMonth() === 4
                        ? 'bg-primary text-white'
                        : 'hover:bg-[#DCE2E7] text-gray-700'
                "
                (click)="setMonth(4)"
            >
                Mai
            </div>

            <div
                class="flex justify-center items-center py-2 px-1 font-bold cursor-pointer rounded transition-colors text-sm"
                [ngClass]="
                    dataInit.getMonth() === 5
                        ? 'bg-primary text-white'
                        : 'hover:bg-[#DCE2E7] text-gray-700'
                "
                (click)="setMonth(5)"
            >
                Jun
            </div>

            <div
                class="flex justify-center items-center py-2 px-1 font-bold cursor-pointer rounded transition-colors text-sm"
                [ngClass]="
                    dataInit.getMonth() === 6
                        ? 'bg-primary text-white'
                        : 'hover:bg-[#DCE2E7] text-gray-700'
                "
                (click)="setMonth(6)"
            >
                Jul
            </div>

            <div
                class="flex justify-center items-center py-2 px-1 font-bold cursor-pointer rounded transition-colors text-sm"
                [ngClass]="
                    dataInit.getMonth() === 7
                        ? 'bg-primary text-white'
                        : 'hover:bg-[#DCE2E7] text-gray-700'
                "
                (click)="setMonth(7)"
            >
                Ago
            </div>

            <div
                class="flex justify-center items-center py-2 px-1 font-bold cursor-pointer rounded transition-colors text-sm"
                [ngClass]="
                    dataInit.getMonth() === 8
                        ? 'bg-primary text-white'
                        : 'hover:bg-[#DCE2E7] text-gray-700'
                "
                (click)="setMonth(8)"
            >
                Set
            </div>

            <div
                class="flex justify-center items-center py-2 px-1 font-bold cursor-pointer rounded transition-colors text-sm"
                [ngClass]="
                    dataInit.getMonth() === 9
                        ? 'bg-primary text-white'
                        : 'hover:bg-[#DCE2E7] text-gray-700'
                "
                (click)="setMonth(9)"
            >
                Out
            </div>

            <div
                class="flex justify-center items-center py-2 px-1 font-bold cursor-pointer rounded transition-colors text-sm"
                [ngClass]="
                    dataInit.getMonth() === 10
                        ? 'bg-primary text-white'
                        : 'hover:bg-[#DCE2E7] text-gray-700'
                "
                (click)="setMonth(10)"
            >
                Nov
            </div>

            <div
                class="flex justify-center items-center py-2 px-1 font-bold cursor-pointer rounded transition-colors text-sm"
                [ngClass]="
                    dataInit.getMonth() === 11
                        ? 'bg-primary text-white'
                        : 'hover:bg-[#DCE2E7] text-gray-700'
                "
                (click)="setMonth(11)"
            >
                Dez
            </div>
        </div>
    </div>
</div>
